import { FC, SVGProps } from 'react';

const DeleteIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#EF5350', size = 18, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M14.1602 7.4696L13.7196 13.5008C13.6285 14.7484 12.5897 15.715 11.3379 15.715H7.02294C5.77187 15.715 4.73235 14.7484 4.64129 13.5001L4.20068 7.4696"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1308 5.20557H3.22949"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8954 5.20476L11.5332 3.42203C11.4281 3.02905 11.0716 2.75586 10.6653 2.75586H7.69804C7.28965 2.75447 6.93171 3.02766 6.82593 3.42203L6.46729 5.20476"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.81299 9.07837V12.3244M10.2469 9.07837V12.3244"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
